<footer class="main-footer">
    <strong>Copyright &copy; 2025 <a style="color: #96D43F;" target="top" href="https://indesad.cl">indesad.cl</a>.</strong>
    Todos los derechos reservados.
    <div class="float-right d-none d-sm-inline-block">
      <b>Version</b> 3.8.2
    </div>
  </footer>